<template>
  <div>
    <generic-modal
      :width="AddressFormModal.width"
      :padding="AddressFormModal.padding"
      :modalClass="AddressFormModal.modalClass"
      overflowNotNeeded="true"
      contentScroll="1"
    >
      <template v-slot:header>
        <div class="sticky-top">
          <div
            class="plr16 pt16 pb16 d-flex align-items-center"
            :class="[clientPlatform == 'Web' ? 'dt-mw-670' : 'border-bottom']"
          >
            <i
              class="hkfi-back fs-14 mr15 hand"
              @click="handleBackIconClick"
            ></i>
            <div class="header-order-details">
              <span class="fs-14 bold lh24">{{ pageHeader }}</span>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:body>
        <toast-msg
          v-if="showItemToastMsg"
          :data-img="staticImgBaseUrl + '/images/global/itemToastIcon.svg'"
          :data-text="itemToastMsg"
          :data-style="'item-toast-msg'"
          :data-text-color="'textWhite'"
        ></toast-msg>
        <div
          class="map-screen-addr-edit-modal"
          :class="AddEditAddressModalDim.modalClass"
        >
          <map-snapshot :mapPinLabel="mapPinLabel"></map-snapshot>
          <div class="d-flex jcsb pt16">
            <div class="location-container align-items-start">
              <img
                :src="staticImgBaseUrl + '/images/global/location-icon.svg'"
                alt="location-icon"
              />
              <div class="location-items">
                <span class="lh18 fs-16 bold color-slaty-dark">{{
                  getTitle
                }}</span>
                <span class="fs-12 lh14 color-slaty">{{ getSubTitle }}</span>
              </div>
            </div>
            <button class="change-btn" @click="changeLocationFromMap">
              {{ changeLabel }}
            </button>
          </div>
          <div class="gradient-stroke-single mt5"></div>
          <div class="addr-types-block addr-inputs">
            <div class="fs-12 medium color-slaty">
              {{ saveThisAddressAsLabel }}
            </div>
            <div class="addr-types">
              <span
                v-for="item in addressData.addressTypes"
                :key="item?.id"
                class="type fs-12"
                :class="[item?.enable ? 'active' : 'non-active']"
                v-on:click="toggleAddressType(item?.id)"
              >
                <img
                  class="addr-type-img"
                  :src="staticImgBaseUrl + item?.iconImage"
                  v-if="item?.left"
                />
                {{
                  item?.name === "Others" && othersText
                    ? othersText
                    : item?.name
                }}
                <img
                  class="addr-type-img pl4"
                  :src="staticImgBaseUrl + item?.iconImage"
                  v-if="!item?.left && !othersText"
                />
              </span>
            </div>
            <div
              class="addr-input others-text"
              :class="{ active: addressData.otherTextArea }"
              v-if="isOthersInputOpen && addressData.addressTypes[2]?.enable"
            >
              <input
                class="input-others"
                :placeholder="othersAddressPlaceholder"
                v-model="addressData.otherTextArea"
              />
              <img
                :src="staticImgBaseUrl + '/images/global/tick-circle.svg'"
                alt="toggle-icon"
                v-if="addressData.otherTextArea"
                @click="updateOthersAddressText()"
              />
            </div>
          </div>
          <div class="addr-inputs">
            <div
              v-if="addressData.building_number || this.focus.addressLine1Label"
            >
              {{ addressLine1Label }}
            </div>
            <input
              class="addr-input"
              v-model="addressData.building_number"
              maxlength="50"
              :placeholder="addressLine1Hint"
              @focus="onFocus('addressLine1Label')"
              @blur="
                onBlur('addressLine1Label');
                emojiErrors.building_number = false;
              "
              v-on:input="validateAddressInput('building_number', $event)"
              @paste="handleAddressPaste('building_number', $event)"
            />
            <div
              v-if="emojiErrors.building_number"
              class="fs-11 color-error mt4"
            >
              Emojis are not allowed
            </div>
            <div v-if="addressData.street_name || this.focus.addressLine2Label">
              {{ addressLine2Label }}
            </div>
            <input
              class="addr-input"
              v-model="addressData.street_name"
              maxlength="50"
              :placeholder="
                addressData.street_name.length > 0 ? '' : addressLine2Hint
              "
              @focus="onFocus('addressLine2Label')"
              @blur="
                onBlur('addressLine2Label');
                emojiErrors.street_name = false;
              "
              v-on:input="validateAddressInput('street_name', $event)"
              @paste="handleAddressPaste('street_name', $event)"
            />
            <div v-if="emojiErrors.street_name" class="fs-11 color-error mt4">
              Emojis are not allowed
            </div>
          </div>

          <div class="addr-contact-inputs" v-if="!isLoggedIn">
            <CustomInput
              :id="'name'"
              :placeholder="'Enter Your Name'"
              :fontSize="'14'"
              :inputClass="'addr-input'"
              :borderColor="'secondary'"
              :borderRadius="'6'"
              :label="'Name'"
              :textLabelClass="'color-secondary'"
              :type="'text'"
              :maxLength="'50'"
              @test="contactNameHandler"
              :value="guestAddressData.name"
              :errorMsgClass="'fs-11 ml10'"
              :is-focus-input="1"
            />
            <CustomInput
              :id="'contact-number'"
              :placeholder="'Enter Your Contact Number'"
              :fontSize="'14'"
              :inputClass="'addr-input'"
              :borderColor="'secondary'"
              :borderRadius="'6'"
              :label="'Contact Number'"
              :textLabelClass="'color-secondary'"
              :type="'number'"
              :maxLength="'10'"
              @test="mobileNumberHandler"
              :value="guestAddressData.contact_number"
              :errorMsgClass="'fs-11 ml10'"
              :is-focus-input="1"
            />
          </div>
          <div class="gradient-stroke-single"></div>
          <div
            class="location-different-nudge"
            v-if="getDistanceDiffText"
            v-html="getDistanceDiffText"
          ></div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="fs-16 color-slaty fw-700">
              {{ labelOrderForSomeoneElse }}
            </div>
            <div @click="toggleOrderForSomeone">
              <img
                :src="staticImgBaseUrl + '/images/global/enableToggleMap.svg'"
                alt="toggle-icon"
                v-if="isOrderForSomeoneElse"
              />
              <img
                :src="staticImgBaseUrl + '/images/global/disableToggleMap.svg'"
                alt="toggle-icon"
                v-else
              />
            </div>
          </div>
          <div class="addr-inputs" v-if="isOrderForSomeoneElse">
            <div v-if="receiverName || this.focus.labelReceiverName">
              {{ labelReceiverName }}
            </div>
            <input
              class="addr-input"
              maxlength="50"
              :placeholder="hintReceiverName"
              v-model="receiverName"
              @focus="onFocus('labelReceiverName')"
              @blur="onBlur('labelReceiverName')"
              v-on:input="elizibleForSaveAddress()"
            />
            <div v-if="mobileNo || this.focus.labelReceiverNumber">
              {{ labelReceiverNumber }}
            </div>
            <div class="mobile-number-container-address mlr0 w100">
              <div class="country-code">+91</div>
              <input
                class="mobile-number-input"
                id="mobileNumberInput"
                type="text"
                name="mobileNoInput"
                inputmode="numeric"
                maxlength="10"
                autocomplete
                v-model="mobileNo"
                :placeholder="hintReceiverNumber"
                @focus="onFocus('labelReceiverNumber')"
                @blur="onBlur('labelReceiverNumber')"
                @input="(event) => handleMobileNo(event)"
              />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div
          class="sticky-footer p16 border-top card-botm-gradient"
          :class="{ plr30vw: clientPlatform == 'Web' }"
        >
          <button
            v-on:click="isLoggedIn ? saveAddress() : saveGuestAddress()"
            class="btn bold secondary fw-700 width100"
            :class="[
              addressData.enableAddSaveAddressBtn ? '' : 'disable-add-addr-btn',
              clientPlatform == 'Web' ? 'abs-botm' : '',
            ]"
          >
            {{ labelSaveAddressbtn }}
          </button>
        </div>
      </template>
    </generic-modal>
    <duplicate-address-popup
      :title="duplicateAddressTitle"
      :subtitle="duplicateAddressSubtitle"
      :primaryCTAText="duplicateAddressPrimaryCTAText"
      :secondaryCTAText="duplicateAddressSecondaryCTAText"
      :duplicateAddress="duplicateAddress"
      v-if="showDuplicateAddressPopup"
    ></duplicate-address-popup>
  </div>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
import LocalStorageFunc from "../helpers/localStorageFunc";
import CustomInput from "./reusableComponents/CustomInput.vue";
import {
  keyMapsMutation,
  keyMapsAction,
  keyMapsGetter,
} from "../helpers/storeKeys";
import Utility from "../helpers/utility";
import DuplicateAddressPopup from "./DuplicateAddressPopup.vue";
import { defineAsyncComponent } from "vue";
import { EVENT_SAVE_ADDRESS_LOCATION } from "../helpers/analyticsEvents";

export default {
  name: "AddEditAddressForm",
  components: {
    GenericModal,
    MapSnapshot: defineAsyncComponent(() => import("./MapSnapshot.vue")),
    DuplicateAddressPopup,
    CustomInput,
    ToastMsg: defineAsyncComponent(() => import("./ToastMsg.vue")),
  },
  props: { moduleProps: {} },
  data() {
    return {
      staticImgBaseUrl,
      isOrderForSomeoneElse: false,
      clientPlatform,
      emojiErrors: {
        building_number: false,
        street_name: false,
      },
      addressData: {
        building_number: "",
        street_name: "",
        addressTypes: [
          {
            id: 1,
            name: "Home",
            enable: false,
            left: true,
            iconImage: "/images/global/homeIcon.svg",
          },
          {
            id: 2,
            name: "Office",
            enable: false,
            left: true,
            iconImage: "/images/global/officeIcon.svg",
          },
          {
            id: 3,
            name: "Others",
            enable: false,
            left: false,
            iconImage: "/images/global/editOthersAddress.svg",
          },
        ],
        addressTypeIdMap: {
          Home: 1,
          Office: 2,
          Others: 3,
        },
        otherTextArea: "",
        enableAddSaveAddressBtn: false,
        addressTypeSelected: "Others",
      },
      guestAddressData: {
        name: "",
        contact_number: "",
      },
      AddressFormModal: {
        width: "100vw",
        height: "100vh",
        padding: "0px",
        modalClass: "full-screen-popup advance-order-modal",
      },
      AddEditAddressModalDim: {
        width: "100vw",
        height: "486px",
        animationStyle: "slide-up-stick-bottom",
        modalClass: "add-edit-address-modal",
      },
      modulePropsData: {},
      saveThisAddressAsLabel: "",
      changeLabel: "",
      addressLine1Label: "",
      addressLine1Hint: "",
      addressLine2Label: "",
      addressLine2Hint: "",
      labelOrderForSomeoneElse: "",
      labelReceiverName: "",
      hintReceiverName: "",
      hintReceiverNumber: "",
      labelReceiverNumber: "",
      labelSaveAddressbtn: "",
      // pageHeader: "",
      othersAddressPlaceholder: "",
      othersText: "",
      mapPinLabel: "",
      distanceNudgeText: "",
      mobileNo: "",
      isOthersInputOpen: false,
      receiverName: "",
      duplicateAddressTitle: "",
      duplicateAddressSubtitle: "",
      duplicateAddressPrimaryCTAText: "",
      duplicateAddressSecondaryCTAText: "",
      isDuplicate: false,
      duplicateAddress: {},
      focus: {
        addressLine1Label: false,
        addressLine2Label: false,
        labelReceiverName: false,
        labelReceiverNumber: false,
      },
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.updateStateFromModuleProps(this.modulePropsData);
    if (
      this.isAddAddressModal &&
      this.$store.state.Location.showManualLocationScreen
    ) {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
        false,
      );
    }

    if (
      LocalStorageFunc.isLoggedIn() &&
      !LocalStorageFunc.getUserAddresses().length
    ) {
      this.$store.dispatch(keyMapsAction.SAVED_ADDRESSES_API);
    }
    if (!LocalStorageFunc.isLoggedIn()) {
      Utility.sendToLoginScreen("/save-address");
    }

    this.checkDuplicateAddress();
    if (Utility.checkEditAddressOnLocation()) {
      this.updateEditAddressState();
    }
    // if (LocalStorageFunc.getLocationChangedAddress() == true) {
    //   this.clearPrefiledAddress();
    // }
    LocalStorageFunc.deleteLocationChangedAddress();
  },
  methods: {
    toggleOrderForSomeone() {
      this.isOrderForSomeoneElse = !this.isOrderForSomeoneElse;
      this.elizibleForSaveAddress();
    },
    onFocus(item) {
      this.focus[item] = true;
    },
    onBlur(item) {
      this.focus[item] = false;
    },
    handleMobileNo(e) {
      this.mobileNo = e.target.value.replace(/[^\d]+/g, "");
      this.elizibleForSaveAddress();
    },
    mobileNumberHandler(e) {
      this.guestAddressData.contact_number = String(e).replace(/\W/gi, "");
      this.elizibleForSaveAddress();
    },
    contactNameHandler(e) {
      this.guestAddressData.name = String(e);
      this.elizibleForSaveAddress();
    },
    clearPrefiledAddress() {
      this.addressData.building_number = "";
      this.addressData.street_name = "";
      this.addressData.addressTypeSelected = "Others";
      this.addressData.enableAddSaveAddressBtn = false;
      for (let i = 0; i < this.addressData.addressTypes.length; i++) {
        this.addressData.addressTypes[i].enable = false;
      }
    },
    updateStateFromModuleProps(propsData) {
      this.saveThisAddressAsLabel = propsData?.saveThisAddressAsLabel;
      this.changeLabel = propsData?.changeLabel;
      this.addressLine1Label = propsData?.addressLine1Label;
      this.addressLine1Hint = propsData?.addressLine1Hint;
      this.addressLine2Label = propsData?.addressLine2Label;
      this.addressLine2Hint = propsData?.addressLine2Hint;
      this.labelOrderForSomeoneElse = propsData?.labelOrderForSomeoneElse;
      this.labelReceiverName = propsData?.labelReceiverName;
      this.labelReceiverNumber = propsData?.labelReceiverNumber;
      this.hintReceiverName = propsData?.hintReceiverName;
      this.hintReceiverNumber = propsData?.hintReceiverNumber;
      this.labelSaveAddressbtn = propsData?.labelSaveAddressbtn;
      // this.pageHeader = propsData?.pageHeader;
      this.othersAddressPlaceholder = propsData?.othersAddressPlaceholder;
      this.mapPinLabel = propsData?.mapPinLabel;
      this.distanceNudgeText = propsData?.distanceNudgeText;
      this.duplicateAddressTitle = propsData?.duplicateAddressTitle;
      this.duplicateAddressSubtitle = propsData?.duplicateAddressSubtitle;
      this.duplicateAddressPrimaryCTAText =
        propsData?.duplicateAddressPrimaryCTAText;
      this.duplicateAddressSecondaryCTAText =
        propsData?.duplicateAddressSecondaryCTAText;
    },
    updateEditAddressState() {
      const editaddress = LocalStorageFunc.getEditAddress();
      this.addressData.building_number = editaddress?.building_number;
      this.addressData.street_name = editaddress?.street_name;
      this.receiverName = editaddress?.recipient_name;
      this.mobileNo = editaddress?.recipient_number;
      const addressType = this.addressData?.addressTypes.find(
        (x) => x.name === editaddress?.customer_address_name,
      );

      if (addressType) {
        addressType.enable = true;
        this.addressData.addressTypeSelected = addressType.name;
      } else {
        this.addressData.addressTypes[2].enable = true;
        this.addressData.addressTypeSelected = "Others";
        this.othersText = editaddress?.customer_address_name;
      }

      if (this.getDistanceDiffText || editaddress?.recipient_name) {
        this.isOrderForSomeoneElse = true;
      }
    },
    toggleAddressType(addressTypeId) {
      for (let i = 0; i < this.addressData.addressTypes.length; i++) {
        if (this.addressData.addressTypes[i].id == addressTypeId) {
          this.addressData.addressTypes[i].enable =
            !this.addressData.addressTypes[i].enable;
          this.addressData.addressTypeSelected = this.addressData.addressTypes[
            i
          ].enable
            ? this.addressData.addressTypes[i].name
            : "Others";
          if (addressTypeId === 3 && this.addressData.addressTypes[2].enable) {
            this.toggleOthersInputOpen(true);
          }
        } else {
          this.addressData.addressTypes[i].enable = false;
        }
      }
      this.elizibleForSaveAddress();
    },
    validateAddressInput(field, event) {
      const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;
      const original = this.addressData[field];
      const stripped = original.replace(emojiRegex, "");
      if (stripped !== original) {
        this.emojiErrors[field] = true;
        this.addressData[field] = stripped;
        this.$nextTick(() => {
          event.target.value = stripped;
        });
      } else {
        this.emojiErrors[field] = false;
      }
      this.elizibleForSaveAddress();
    },
    handleAddressPaste(field, event) {
      event.preventDefault();
      const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;
      const text = event.clipboardData.getData("text");
      const cleaned = text.replace(emojiRegex, "");
      if (cleaned !== text) {
        this.emojiErrors[field] = true;
      }
      const input = event.target;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const current = this.addressData[field];
      const newValue = (
        current.substring(0, start) +
        cleaned +
        current.substring(end)
      ).substring(0, 50);
      this.addressData[field] = newValue;
      this.$nextTick(() => {
        input.value = newValue;
        const newCursor = Math.min(start + cleaned.length, 50);
        input.setSelectionRange(newCursor, newCursor);
      });
      this.elizibleForSaveAddress();
    },
    elizibleForSaveAddress() {
      const { building_number, street_name, addressTypeSelected } =
        this.addressData;
      const { name, contact_number } = this.guestAddressData;
      const isValidAddress =
        building_number !== "" &&
        street_name !== "" &&
        addressTypeSelected?.length > 0;
      const isValidMobile = this.mobileNo?.length === 10;
      const isValidGuest = name !== "" && contact_number.length === 10;
      const isValidReceiver =
        this.receiverName !== "" && this.mobileNo !== "" && isValidMobile;

      const isAddressDataChanged =
        this.addressData.building_number !==
          this.getEditAddress?.building_number ||
        this.addressData.street_name !== this.getEditAddress?.street_name ||
        this.addressData.addressTypeSelected !==
          this.getEditAddress?.customer_address_name ||
        (this.isOrderForSomeoneElse &&
          (this.receiverName !== this.getEditAddress?.recipient_name ||
            this.mobileNo !== this.getEditAddress?.recipient_number));

      const isValidOrder =
        !this.isOrderForSomeoneElse ||
        (this.isOrderForSomeoneElse && isValidReceiver);

      if (!this.showEditAddressFlow) {
        if (this.isLoggedIn) {
          if (isValidAddress && isValidOrder) {
            this.addressData.enableAddSaveAddressBtn = true;
            return;
          }
        } else {
          if (isValidAddress && isValidGuest && isValidOrder) {
            this.addressData.enableAddSaveAddressBtn = true;
            return;
          }
        }
      } else {
        let addressObj = this.$store.state.Location.googleAddressComponent
          ?.addressComponents
          ? Utility.getAddressObject(
              this.$store.state.Location.googleAddressComponent,
            )
          : {};

        if (
          isValidAddress &&
          (this.isLoggedIn
            ? (isAddressDataChanged ||
                addressObj?.latitude !== this.getEditAddress?.latitude ||
                addressObj?.longitude !== this.getEditAddress?.longitude) &&
              isValidOrder
            : (isAddressDataChanged ||
                this.guestAddressData.name !== this.getEditAddress?.name ||
                this.guestAddressData.contact_number !==
                  this.getEditAddress?.contact_number) &&
              isValidGuest &&
              isValidOrder)
        ) {
          this.addressData.enableAddSaveAddressBtn = true;
          return;
        }
      }
      this.addressData.enableAddSaveAddressBtn = false;
    },
    updateOthersAddressText() {
      this.othersText = this.addressData.otherTextArea;
      this.toggleOthersInputOpen();
      this.elizibleForSaveAddress();
    },
    toggleOthersInputOpen(flag = false) {
      this.isOthersInputOpen = flag;
    },
    saveAddress() {
      if (!this.addressData.enableAddSaveAddressBtn) return;

      const addressObj = this.createAddressObject();
      const isEditFlow = this.showEditAddressFlow;
      const action = isEditFlow
        ? keyMapsAction.UPDATE_ADDRESS_API
        : keyMapsAction.ADD_ADDRESS_API;
      const successMessage = isEditFlow
        ? "Address Updated Successfully"
        : "Address Added Successfully";

      EVENT_SAVE_ADDRESS_LOCATION({
        category: isEditFlow ? "Address updated" : "Address saved",
        subcategory: this.isOrderForSomeoneElse
          ? "ordering for someone else"
          : "ordering for self",
      });
      if (this.noDeliveryZoneData?.displayText) {
        this.changeLocationFromMap();
      } else {
        this.$store
          .dispatch(action, { saveAddressRequest: addressObj })
          .then(() => this.handleSuccess(addressObj, successMessage))
          .catch(() => this.handleError());
      }
    },

    createAddressObject() {
      const {
        building_number,
        street_name,
        addressTypeSelected,
        otherTextArea,
      } = this.addressData;
      const addressObj = Utility.getAddressObject(
        this.$store.state.Location.googleAddressComponent,
      );
      if (this.getEditAddress?.address_id) {
        addressObj.address_id = this.getEditAddress?.address_id;
      }
      addressObj.building_number = building_number;
      addressObj.street_name = street_name;
      addressObj.customer_address_name =
        addressTypeSelected === "Others"
          ? otherTextArea
            ? otherTextArea
            : "Others"
          : addressTypeSelected;
      addressObj.formatted_address = `${building_number}, ${street_name}`;
      addressObj.order_for_someone_else = this.isOrderForSomeoneElse;

      if (this.isOrderForSomeoneElse) {
        addressObj.recipient_name = this.receiverName;
        addressObj.recipient_number = this.mobileNo;
      }

      return addressObj;
    },

    handleSuccess(addressObj, message) {
      // this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
      // this.$store.commit(keyMapsMutation.UPDATE_ITEM_TOAST_MSG, message);

      LocalStorageFunc.setToastNotifications({
        msg: message,
      });

      let selectedAddress = LocalStorageFunc.getSelectedUserAddress();
      if (selectedAddress?.address_id === addressObj.address_id) {
        this.$store.commit(
          keyMapsMutation.UPDATE_SELECTED_USER_ADDRESS,
          addressObj,
        );
        LocalStorageFunc.setLocalStorageValue("selectedAddress", addressObj);
      }

      // setTimeout(this.updateDisableItemToastMsg, 1000);
      this.closeAddressModal();
      setTimeout(this.redirectAfterSaveAddress, 100);
    },

    handleError() {
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
      setTimeout(this.updateDisableItemToastMsg, 3000);
    },

    updateDisableItemToastMsg() {
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, false);
    },
    saveGuestAddress() {
      if (!this.addressData.enableAddSaveAddressBtn) return;

      const addressObj = this.createGuestAddressObject();
      const savedAddressItems = this.getSavedAddressItems();
      const newAddress = this.createNewAddress(
        addressObj,
        savedAddressItems.length,
      );

      if (!this.showEditAddressFlow) {
        this.saveNewAddress(newAddress, addressObj, savedAddressItems);
      } else {
        this.updateExistingAddress(newAddress, savedAddressItems);
      }
    },

    createGuestAddressObject() {
      const {
        building_number,
        street_name,
        addressTypeSelected,
        otherTextArea,
      } = this.addressData;
      return {
        ...Utility.getAddressObject(
          this.$store.state.Location.googleAddressComponent,
        ),
        building_number,
        street_name,
        customer_address_name:
          addressTypeSelected === "Others"
            ? otherTextArea
            : addressTypeSelected,
        formatted_address: `${building_number}, ${street_name}`,
      };
    },

    getSavedAddressItems() {
      return Utility.tryJsonParse(
        localStorage.NON_LOGGED_IN_SAVED_ADDRESSES,
        [],
      );
    },

    createNewAddress(addressObj, savedAddressCount) {
      const {
        street_name,
        building_number,
        customer_address_name,
        latitude,
        longitude,
      } = addressObj;
      return {
        latitude,
        longitude,
        ...(this.showEditAddressFlow && {
          address_id: this.getEditAddress?.address_id,
        }),
        customer_address_name,
        building_number,
        formatted_address: street_name,
      };
    },

    saveNewAddress(newAddress, addressObj, savedAddressItems) {
      const { first_name, last_name, email, mobile_no } = addressObj;
      const addressValues = {
        fName: first_name || this.guestAddressData.name,
        lName: last_name || "",
        email: email || "",
        mobNo: this.guestAddressData.contact_number || mobile_no,
        address: addressObj.street_name,
        houseNo: addressObj.building_number,
      };

      Object.keys(addressValues).forEach((key) => {
        this.$store.commit(keyMapsMutation.SAVE_ADDRESS_DETAILS, {
          fieldName: key,
          fieldValue: addressValues[key],
        });
      });

      savedAddressItems.push(newAddress);
      localStorage.NON_LOGGED_IN_SAVED_ADDRESSES =
        JSON.stringify(savedAddressItems);

      this.$store.commit(
        keyMapsMutation.UPDATE_SELECTED_USER_ADDRESS,
        newAddress,
      );
      LocalStorageFunc.setToastNotifications({
        msg: "Address changed successfully!",
      });
      Utility.sendToCartScreen();
    },

    updateExistingAddress(newAddress, savedAddressItems) {
      const searchIndex = savedAddressItems.findIndex(
        (item) => item.address_id == newAddress.address_id,
      );
      if (searchIndex !== -1) {
        savedAddressItems[searchIndex] = newAddress;
        localStorage.NON_LOGGED_IN_SAVED_ADDRESSES =
          JSON.stringify(savedAddressItems);
        this.$store.commit(
          keyMapsMutation.UPDATE_SELECTED_USER_ADDRESS,
          newAddress,
        );
        LocalStorageFunc.setToastNotifications({
          msg: "Address changed successfully!",
        });
        Utility.sendToCartScreen();
      }
    },
    closeAddressModal(timeout = 100) {
      setTimeout(() => {
        this.closeAddEditAddressModal();
        Utility.removeAddEditAddressFromStorage();
      }, timeout);
    },
    redirectAfterSaveAddress() {
      let redirectFrom = LocalStorageFunc.getIsRedirectedFrom();
      LocalStorageFunc.setIsRedirectedFrom("");
      if (redirectFrom == "/my-addresses") {
        Utility.sendToMyAddressPage();
      } else if (redirectFrom == "/cart-unified") {
        Utility.sendToCartScreen();
      } else if (redirectFrom == "/location") {
        this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
        true,
      );
        Utility.sendToLocationScreen({ noRedirectUrl: true });
      } else {
        Utility.sendToHomepageScreen();
      }
    },
    checkDuplicateAddress() {
      let savedAddresses =
        this.$store.getters[keyMapsGetter.GET_REARRANGED_SAVED_ADDRESS]();
      let markerLocation = this.$store.state.Location.currentLocation;
      savedAddresses.map((x) => {
        if (
          Utility.checkIfNewLocationMatchesSavedAddress(
            markerLocation.lat,
            markerLocation.lng,
            x,
          )
        ) {
          this.isDuplicate = true;
          this.duplicateAddress = x;
          return;
        }
      });
    },
    toggleIsDuplicate() {
      this.isDuplicate = false;
    },
    changeLocationFromMap() {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
        false,
      );
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_DELIVERY_MAP_SCREEN, true);
      Utility.sendToLocationScreen(window.location);
    },
    closeAddEditAddressModal() {
      LocalStorageFunc.setIsAddEditAddressFlow(false);
      LocalStorageFunc.setCoordsForAddEditAddress({});
      this.$store.commit(
        keyMapsMutation.TOGGLE_ADD_EDIT_ADDRESS_LOCATION_SCREEN,
        false,
      );
      Utility.removeAddEditAddressFromStorage();
    },
    handleBackIconClick() {
      if (!Utility.isTakeawayOrDineinSelected()) {
        LocalStorageFunc.setIsAddEditAddressFlow(false);
        LocalStorageFunc.setAddAddressEnable(false);
        LocalStorageFunc.setCoordsForAddEditAddress({});
      }
      LocalStorageFunc.setEditAddresEnable({});
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
        true,
      );
      // Utility.redirectToHomeOrRedirectUrl();
      this.redirectAfterSaveAddress()
    },
  },
  computed: {
    initialValue() {
      return this.$store.state.Location.geoCodeInitialValue;
    },
    getTitle() {
      return Object.keys(this.getEditAddress).length
        ? this.getEditAddress?.customer_address_name
        : this.initialValue.geoCode.displayAddress;
    },
    getSubTitle() {
      return Object.keys(this.getEditAddress).length
        ? this.getEditAddress?.formatted_address
        : this.initialValue.geoCode.footerAddress;
    },
    getEditAddress() {
      return LocalStorageFunc.getEditAddress();
    },
    isOnLocationPage() {
      return Utility.isCurrentlyAtUrl("/location");
    },
    showItemToastMsg() {
      return this.$store.state.Cart.showItemToastMsg;
    },
    itemToastMsg() {
      return this.$store.state.Cart.itemToastMsg;
    },
    isAddAddressModal() {
      if (this.showEditAddressFlow) {
        return this.$store.state.User.showEditAddressLocationScreen;
      } else {
        return (
          this.$store.state.User.showAddAddressLocationScreen &&
          !this.$store.state.Location.noDeliveryZoneData.location
        );
      }
    },
    showEditAddressFlow() {
      return Object.keys(this.getEditAddress).length;
    },
    pageHeader() {
      return this.showEditAddressFlow
        ? "Edit Delivery Address"
        : "Add Delivery Address";
    },
    isLoggedIn() {
      return LocalStorageFunc.isLoggedIn();
    },
    currentLocation() {
      return this.$store.state.Location.currentGPSLocationData?.geometry
        ?.location;
    },
    markerLocation() {
      return this.$store.state.Location.currentLocation;
    },
    getDistanceDiff() {
      return this.currentLocation?.lat && this.markerLocation?.lat
        ? Utility.distanceBetweenTwoCoordinates(
            this.currentLocation,
            this.markerLocation,
          )
        : 0;
    },
    getDistanceDiffText() {
      let diff = this.getDistanceDiff;
      let dist =
        diff > 300
          ? Math.trunc(diff) > 1000
            ? `${(Math.trunc(diff) / 1000).toFixed(1)}Km`
            : `${Math.trunc(diff)}m`
          : "";
      return dist ? this.distanceNudgeText.replace("<distance>", dist) : "";
    },
    noDeliveryZoneData() {
      return this.$store.state.Location?.noDeliveryZoneData?.displayText
        ? this.$store.state.Location?.noDeliveryZoneData
        : LocalStorageFunc.getNoDeliveryZoneData();
    },
    showDuplicateAddressPopup() {
      return (
        this.isDuplicate &&
        LocalStorageFunc.getAddAddressEnable() &&
        !Object.keys(this.getEditAddress).length
      );
    },
  },
};
</script>

<style></style>
